module.exports = __webpack_public_path__ + "static/media/everyday_digital_footy2024.a31d829b.webp";